angular.module('swapick')
.controller('NewObjectCtrl', NewObjectCtrl)
.controller('EditObjectCtrl', EditObjectCtrl);


function NewObjectCtrl($scope, $http, DataService, $stateParams, $timeout,
    Entities, Categories, initialLoaderManager, $ionicModal, $ionicPopup,
    $ionicLoading, $cordovaCamera, $cordovaImagePicker, $cordovaFile,
    $state, $ionicHistory, $q, ObjectsService, $rootScope, Enums,
    ReloadControllers, DataStrategies, $ionicScrollDelegate, $ionicBody) {

    $scope.vm = this;
    this.obj =  {attributi:{}, altre_immagini:[]};
    this.conditionValues = Enums.getConditionsOptions('');
    this.attrs = [];
    this.isCordova = !!window.cordova;
    this.currentServices = {};
    this.currentPackages = {};
    this.noServices = false;
    this.servicesModal = null;

    // Is the searching for object done?
    this.searchObjectDone = false;
    this.searchEnabled = false;

    // Search object query
    this.searchObjectQuery = null;

    // Pager methods for search modal, select difficulty
    this.searchObjectData = {};
    DataStrategies.createPagerMethods(
      this.searchObjectData,
      $scope,
      {
        method: DataService.base.all('api/items'),
        callMethodName: 'getList',
        pageSize: 33,
        hasSearch: true, // TODO: Not sure is better true or false O.o
        params: () => ({
          cat_id : this.obj.categoria,
          world_id : this.obj.mondo,
          // TODO: Is user id relevant for this request?
          // user_id : ???
          q : this.searchObjectQuery,
        })
      }
    );

    this.loader = initialLoaderManager.makeLoader(()=>{

        return Categories
        .getCategories()
        .then(categories => {
          this.categoriesData = Categories.data;
          return Entities.waitForUser()
          .then((u)=>{
            this.user = u;
            return u;
          })
        })
        .then(u => {
          return DataService.services.getList()
          .then(services => {
            this.services = _.filter(services, i => i.tipo && i.soggetto=='item');
            return services
          })
        })
        .then(services => {
          return DataService.packages.getList()
          .then(packages => {
            this.packages = packages;
            return packages;
          })
        })

    }, false);

    // TODO: This categories and world are not realy debug purpose only...
    const searchObjectEnabledCategories = [ 1, 2, 3, 4, 50 ];
    // Re-calculate search done
    // TODO: if we want to show search behaviour only one times
    // simply if searchDone alredy false keep it false =)
    this.calculateSearchDone = () => {
      if (typeof this.obj.categoria === 'undefined') {
          this.searchEnabled = false;
          this.searchObjectDone = false;
      } else {
        this.searchEnabled = (
          searchObjectEnabledCategories.indexOf(this.obj.categoria) !== -1
        );
        if(!this.searchEnabled){
          this.searchObjectDone = true;
        }

      }
      // Empty the search string
      this.searchObjectQuery = null;


    };

    this.searchForObject = () => {
      $ionicScrollDelegate.$getByHandle('searchScroll').resize();
      this.searchObjectData.search();
    }

    this.resetSearchObject = () => {
      this.searchObjectDone=false;
      this.searchObjectQuery='';
    }

    // Start searching for object
    this.startSearchObject = () => {
      this.searchObjectModal.show().then(()=>{
        this.searchForObject();
      });
    };

    // End searching keep insert object stuff...
    this.endSearchObject = () => {
      this.searchObjectDone = true;
      this.searchObjectModal.hide();
    };

    // Method used in object-grid directive
    // Monkey patching the world...
    this.toObjPage = (...args) => {
      this.searchObjectModal.remove()
        .then(() => $scope.AppCtrl.toObjPage(...args))
    };

    this.getCategoriesForMondo = (mondo) => {
      return ObjectsService.getCategoriesForMondo(mondo, this.categoriesData)
    }

    this.calculateAttributes = () => {
        this.attrs = ObjectsService.calculateAttributes(this.obj, this.categoriesData);
        this.conditionValues = Enums.getConditionsOptions(this.obj.categoria);
    }

    this.mainImageChange = (img)=>{
      $timeout(()=>{
        this.obj.immagine = img;
      });
    }

    this.imageChange = (img)=>{
      $timeout(()=>{
        this.obj.altre_immagini.push({image:img, id:_.uniqueId()});
      });
    }

    this.dropImage = (idx) =>{
     $timeout(()=>{
        this.obj.altre_immagini.splice(idx, 1);
      })
    };

    this.getCameraImage = (source="CAMERA", destination=null )=>{
      return ObjectsService
      .getCameraImage(source, destination)
      .then(out => {
        if(!destination){
          this.obj.immagine = out;
        } else {
          this.obj.altre_immagini.push({image: out, id:_.uniqueId()});
        }
        return out;
      });
    }

    this.getGalleryImage = ()=>{
      console.log("gallery image...")
      return ObjectsService.getGalleryImage()
      then(out => {
        this.obj.immagine = out;
        return out;
      });
    }

    this.getAdditionalServices = () => {

      //temporarily disabling services
      return this.saveNewObject()

      if(!this.servicesModal){ return }
      //updating ecoins
      return DataService.ecoins
      .get()
      .then(resp => {
        $rootScope.globals.userEcoins = parseInt(resp);
        return this.servicesModal.show();
      })
    }

    this.validServices = () => {
      return this.noServices || _.keys(this.currentServices).length || _.keys(this.currentPackages).length;
    }

    this.enoughEcoins = ObjectsService.enoughEcoins;

    this.checkResetServices = () => {
      if(!this.noServices){ return }
      this.currentServices = {};
      this.currentPackages = {};
    }

    //#TODO: same code in ObjectCtrl
    this.checkResetNoServices = (item) => {
      this.noServices = false;
      let chiave = item.tipo ? item.tipo.chiave : null;
      _.each(this.services, (v) => {
        //reset all services with different key
        if((v.id && v.id != item.id && chiave && v.tipo.chiave === chiave)){
          this.currentServices[v.id] = false;
        }
      });

      _.each(this.packages, (v) => {
        //resets all packages
        if(v.id != item.id){
          this.currentServices[v.id] = false;
        }
      });

      //packages. Resetting all services.
      if(!item.tipo && item.servizi && item.servizi.length){
        _.each(this.services, (v) => {
          if(v.id != item.id && v.tipo){
            this.currentServices[v.id] = false;
          }
        });
      }
    }


    this.shopServices = (services, packages) =>
      ObjectsService.shopServices(
        ObjectsService.prepareServices(this.currentServices, this.obj.id),
        this.currentPackages);

    this.saveNewObject = () => {
      //this.servicesModal.show()
      $ionicLoading.show();

      return this.saveNewObjectToServer()
      .then((resp)=>{
          this.obj.id = resp.id;
          return this.shopServices();
      })
      .then(()=>{
        $ionicHistory.nextViewOptions({
          disableBack: true,
          historyRoot : true,
        });
        return $state.go("app.logged.object", {objectId:this.obj.id, userId:this.user.id});
      })

      /*
      return this.shopServices()
      .then(()=>{
          return this.saveNewObjectToServer();
      })
      .catch(err=>{
        return console.error("error in shopping", err)
      })
      */
      .finally(() => {
        $ionicLoading.hide();
      })
    }

    this.saveNewObjectToServer = () => ObjectsService.saveNewObjectToServer(this.obj, this.user.id);
    this.saveNewInterest = ()=>{
      $ionicLoading.show();
      return ObjectsService.saveNewInterestToServer(this.obj, this.user.id)
      .then(()=>{
        ReloadControllers.notifyReload('WantedCtrl');
        return $state.go("app.logged.wanted", {type:'interessi'});
      })
      .finally(()=>{
        $ionicLoading.hide();
      })
    }


    this.getSelectOptions = ObjectsService.getSelectOptions;
    this.getAutocompleteOptions = ObjectsService.getAutocompleteOptions;
    this.getCallbackMethod = ObjectsService.getCallbackMethod;
    this.getModelToItem = ObjectsService.getModelToItem;

    $ionicModal.fromTemplateUrl('templates/object-services-modal.html', {
      scope: $scope
    }).then(modal => {
      this.servicesModal = modal;
    });

    $ionicModal.fromTemplateUrl('templates/ecoin-buy-modal.html', {
      scope: $scope
    }).then(modal => {
      this.ecoinModal = modal;
    });

    $ionicModal.fromTemplateUrl('templates/search-object-modal.html', {
      scope: $scope
    }).then(modal => {
      this.searchObjectModal = modal;
    });

    $scope.$on('$destroy', () => {
      this.servicesModal.remove();
      this.ecoinModal.remove();
      this.searchObjectModal.remove();
      //fix for https://github.com/driftyco/ionic-v1/pull/219/commits
      $ionicBody.removeClass('modal-open');

    });

    $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.categoriesData){
        this.loader.load();
      }
    });
}



function EditObjectCtrl($scope, $http, DataService, $stateParams, $timeout,
    Entities, Categories, initialLoaderManager, $ionicModal, $ionicPopup,
    $ionicLoading, $cordovaCamera, $cordovaImagePicker, $cordovaFile,
    $state, $ionicHistory, $q, ObjectsService, $rootScope, Enums, $ionicBody ) {

    //this.obj =  {attributi:{}, altre_immagini:[]};

    $scope.vm = this;
    this.conditionValues = Enums.getConditionsOptions('');
    this.attrs = [];
    this.isCordova = !!window.cordova;
    this.currentServices = {};
    this.currentPackages = {};
    this.noServices = false;
    this.servicesModal = null;

    this.loader = initialLoaderManager.makeLoader(()=>{

        return Categories
        .getCategories()
        .then(categories => {
          this.categoriesData = Categories.data;
          return
        })
        .then(() => {
          return Entities.waitForUser()
        })
        .then((u)=>{
          this.user = u;
          return u;
        })
        .then(() => {
          if($stateParams.passedObject == $stateParams.objectId){
            return $stateParams.passedObject
          }
          return DataService.items.one($stateParams.objectId).get();
        })
        .then(obj => {
          this.obj = obj

          this.obj.categoria = this.obj.categoria.id;
          this.obj.mondo = this.categoriesData.categoriesById[this.obj.categoria][0].mondo.id;
          this.obj.valore = parseInt(this.obj.posseduto_da[0].valore);
          this.obj.condizioni = parseInt(this.obj.posseduto_da[0].condizioni);
          this.obj.altre_immagini = this.obj.altre_immagini.map(item => ({ percorso:item.percorso, id:_.uniqueId()}))
          return this.obj;
        })
        .then(() => {
          return DataService.services.getList()
          .then(services => {
            this.services = _.filter(services, i => i.tipo && i.soggetto=='item');
            return services
          })
        })
        .then(services => {
          return DataService.packages.getList()
          .then(packages => {
            this.packages = packages;
            //#TODO: enable this for attribute editing (needs template)
            //this.calculateAttributes();
            return packages;
          })
        })

    }, false);

    this.getCategoriesForMondo = (mondo) => {
      return ObjectsService.getCategoriesForMondo(mondo, this.categoriesData)
    }

    this.calculateAttributes = () => {
        this.attrs = ObjectsService.calculateAttributes(this.obj, this.categoriesData);
        this.conditionValues = Enums.getConditionsOptions(this.obj.categoria);

    }

    this.mainImageChange = (img)=>{
      $timeout(()=>{
        this.obj.immagine = img;
      });
    }

    this.imageChange = (img)=>{
      $timeout(()=>{
        this.obj.altre_immagini = this.obj.altre_immagini || [];
        this.obj.altre_immagini.push({image:img, id:_.uniqueId()});
      });
    }

    this.dropImage = (idx) =>{
     $timeout(()=>{
        this.obj.altre_immagini.splice(idx, 1);
      })
    };

    this.getCameraImage = (source="CAMERA", destination=null )=>{
      return ObjectsService
      .getCameraImage(source, destination)
      .then(out => {
        if(!destination){
          this.obj.immagine = out;
        } else {
          this.obj.altre_immagini.push({image: out, id:_.uniqueId()});
        }
        return out;
      });
    }

    this.getGalleryImage = ()=>{
      console.log("gallery image...")
      return ObjectsService.getGalleryImage()
      then(out => {
        this.obj.immagine = out;
        return out;
      });
    }

    this.getAdditionalServices = () => {

      //temporarily disabling services
      return this.saveNewObject()

      if(!this.servicesModal){ return }
      //updating ecoins
      return DataService.ecoins
      .get()
      .then(resp => {
        $rootScope.globals.userEcoins = parseInt(resp);
        return this.servicesModal.show();
      })
    }

    this.validServices = () => {
      return this.noServices || _.keys(this.currentServices).length || _.keys(this.currentPackages).length;
    }

    this.enoughEcoins = ObjectsService.enoughEcoins;

    this.checkResetServices = () => {
      if(!this.noServices){ return }
      this.currentServices = {};
      this.currentPackages = {};
    }

    this.checkResetNoServices = (item) => {
      this.noServices = false;
      let chiave = item.tipo ? item.tipo.chiave : null;
      if(chiave){
        _.each(this.services, (v) => {
          if(v.id != item.id && v.tipo.chiave === chiave){
            this.currentServices[v.id] = false;
          }
        })
      }
    }

    this.shopServices = (services, packages) =>
      ObjectsService.shopServices(
        ObjectsService.prepareServices(this.currentServices, this.obj.id),
        this.currentPackages);

    this.saveNewObject = () => {
      $ionicLoading.show();
      return this.saveObjectToServer()
      //return this.shopServices()
      //.then(()=>{
      //    return this.saveObjectToServer();
      //})
      .then(()=>{
        $ionicHistory.nextViewOptions({
          disableBack: true,
          historyRoot : true,
        });
        return $state.go("app.logged.object", {objectId:this.obj.id, userId:this.user.id});
      })
      .catch(err=>{
        return console.error("error in shopping", err)
      })
      .finally(() => {
        $ionicLoading.hide();
      })
    }

    this.saveObjectToServer = () => ObjectsService.saveObjectToServer(this.obj, this.user.id);


    this.getSelectOptions = ObjectsService.getSelectOptions;
    this.getAutocompleteOptions = ObjectsService.getAutocompleteOptions;
    this.getCallbackMethod = ObjectsService.getCallbackMethod;
    this.getModelToItem = ObjectsService.getModelToItem;


    $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.categoriesData){
        this.loader.load();
      }
    });

    $ionicModal.fromTemplateUrl('templates/object-services-modal.html', {
      scope: $scope
    }).then(modal => {
      this.servicesModal = modal;
    });

    $ionicModal.fromTemplateUrl('templates/ecoin-buy-modal.html', {
      scope: $scope
    }).then(modal => {
      this.ecoinModal = modal;
    });

    $scope.$on('$destroy', () => {
      this.servicesModal.remove();
      this.ecoinModal.remove();
      //fix for https://github.com/driftyco/ionic-v1/pull/219/commits
      $ionicBody.removeClass('modal-open');
    });

}



// WEBPACK FOOTER //
// ./src/controllers/new-object-controller.js